<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'tc-fabricOrder',
  components: {
    PageTable,
  },
}
</script>
